import React from "react";
import { InputAdornment, Select, MenuItem } from "@material-ui/core";
import { Small } from "@common/typography/Small";
import locale from "@bonliva-crm/locale";
type Props = {
  value: string;
  className: string;
  onChange: (value: string) => void;
};
export const SearchType = ({ value, className, onChange }: Props) => (
  <InputAdornment position="end" className={className}>
    <Select
      className={className}
      disableUnderline
      fullWidth
      value={value}
      SelectDisplayProps={
        {
          "data-test": "Searchtype"
        } as any
      }
      startAdornment={
        <InputAdornment position="start" style={{ whiteSpace: "nowrap" }}>
          <Small>{locale.IncludeComments}:</Small>
        </InputAdornment>
      }
      onChange={(e) => onChange(e.target.value as string)}
    >
      <MenuItem value="basic" data-test="SearchtypeSimple">
        {locale.No}
      </MenuItem>
      <MenuItem value="extended" data-test="SearchtypeFull">
        {locale.Yes}
      </MenuItem>
    </Select>
  </InputAdornment>
);
